"use client"
import {useEffect, useState} from "react";

export default function Preloader({siteConfig}) {
    const [showLoader, setShowLoader] = useState(true);
    const [isLoaded, setIsLoaded] = useState(null);

    const defaultLoaderConfig = {
        animation: ["P", "O", "L", "N"],
        message:
            "NETWORK",
        loadMessage:
            "Loading"
    }

    const lc = siteConfig?.loaderConfig || defaultLoaderConfig;
    //console.log("SC ==>", siteConfig)

    useEffect(() => {
        window.addEventListener("load", () => {
            setIsLoaded("loaded");
        });

        const timer = setTimeout(() => {
            setShowLoader(false);
        }, 500);

        return () => clearTimeout(timer);
    });
    return (
        showLoader && (
            <div id="preloader" className={`preloader ${isLoaded}`}>
                <div className="animation-preloader">
                    <div className="spinner"></div>
                    <div className="txt-loading">
                        {lc.animation.map((l, i) => (
                            <span key={`l-${i}`} data-text-preloader={l} className="letters-loading">{l}</span>))}
                    </div>
                    <h3 className="text-center">{lc.message}</h3>
                    <p className="text-center">{lc.loadMessage}</p>
                </div>
                <div className="loader">
                    <div className="row">
                        {lc.animation.map((l, i) => (<div key={`l-${i}`} className="col-3 loader-section section-left">
                            <div className="bg"></div>
                        </div>))}
                    </div>
                </div>
            </div>
        )
    );
}
